import React from 'react';
import { Form } from '@dashboard/components/Formik';
import usePage from '@dashboard/hooks/usePage';

const GoogleIndexForm = () => {
  const { page, updatePage } = usePage();

  return (
    <Form
      initialValues={{
        googleIndex: page.googleIndex,
      }}
      fields={[
        {
          name: 'googleIndex',
          type: 'checkbox',
          label: 'Index page in Google',
        },
      ]}
      onSubmit={async (values, actions) => {
        const { data, error } = await updatePage.mutateAsync(values);

        if (data) {
          actions.resetForm({
            values: {
              googleIndex: data.googleIndex,
            },
          });
        }

        return {
          data,
          error,
        };
      }}
    />
  );
};

export default GoogleIndexForm;
